export default __webpack_public_path__ + "static/media/img-0602-liechtenstein-full-face.874bfdc8.png";